import { render, staticRenderFns } from "./RsxAnswerReference.vue?vue&type=template&id=0dba55a0&scoped=true"
import script from "./RsxAnswerReference.vue?vue&type=script&lang=js"
export * from "./RsxAnswerReference.vue?vue&type=script&lang=js"
import style0 from "./RsxAnswerReference.vue?vue&type=style&index=0&id=0dba55a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dba55a0",
  null
  
)

export default component.exports